import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ApiTokenService } from '@core/services/api-token.service';
import { environment } from '@env/environment';

/**
 * HTTP interceptor that auto-attaches the `Authorization: Bearer <token>` header
 * to every outgoing request whose URL starts with the configured `apiBaseUrl`.
 *
 * This replaces the per-service manual `getAuthHeaders()` approach.
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  // Only add auth headers to our own API requests
  if (!req.url.startsWith(environment.apiBaseUrl)) {
    return next(req);
  }

  const tokenService = inject(ApiTokenService);
  const token = tokenService.getToken();

  if (!token) {
    return next(req);
  }

  const authReq = req.clone({
    setHeaders: { Authorization: `Bearer ${token}` },
  });

  return next(authReq);
};
